import { applyAction } from "./appliers";
import type { OblivionMineAction, OblivionMineState } from "./types";
import { validateAction } from "./validators";

export interface ReduceResult {
  readonly state: OblivionMineState;
  readonly accepted: boolean;
  readonly error?: string;
}

// NOTE: does NOT validate — call validateAndReduceGameState at trust boundaries.
export function reduceGameState(
  state: OblivionMineState,
  action: OblivionMineAction,
): OblivionMineState {
  return applyAction(state, action);
}

export function validateAndReduceGameState(
  state: OblivionMineState,
  action: OblivionMineAction,
): ReduceResult {
  const validation = validateAction(state, action);
  if (!validation.valid) {
    return { state, accepted: false, error: validation.error };
  }
  return { state: reduceGameState(state, action), accepted: true };
}
